module.exports = __webpack_public_path__ + "img/across chest.d60e3687.png";